<template>
  <div class="snsBtns">
    <div class="tit">{{ isCounselorNameCustom ? '상담직원 바로 연결하기' : '상담사 바로 연결하기' }}</div>
    <div class="listBtn">
      <div>
        <a
          @click="clickedCategory(item, messageType, idx, chat)"
          v-for="(item, idx) in counselorButtons"
          :key="idx"
          :class="[item.channelName === 'NAVER_TALK' ? 'list naverTalk' : 'list']"
          v-show="item.type === 'COUNSELOR_BUTTON'"
        >
          <p v-if="item.channelName === 'KAKAO_TALK'">
            <img src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_kakao.png" /><span>카카오톡</span>
          </p>
          <p v-if="item.channelName === 'NAVER_TALK'">
            <img src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_naver.png" /><span>네이버톡톡</span>
          </p>
          <p v-if="item.channelName === 'WEB_CHAT'">
            <img src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_webchat_v2.png" /><span>웹챗</span>
          </p>
          <p v-if="item.channelName === 'FACEBOOK_TALK'">
            <img src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_facebook_messenger.png" /><span>페이스북</span>
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getNameCustomList } from '@/constants/customInfo';

export default {
  name: 'CounselorButtons',
  props: ['counselorButtons', 'messageType', 'clickedCategory', 'chat'],
  computed: {
    ...mapGetters(['getBrandId']),
    isCounselorNameCustom() {
      return getNameCustomList().brands.includes(this.getBrandId);
    }
  }
};
</script>

<style scoped></style>
